// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/utilities/assets/backgroundimg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.7 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

* {
  scrollbar-color: initial;
  scrollbar-width: initial;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.relative {
  position: relative;
}
.z-10 {
  z-index: 10;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.ml-10 {
  margin-left: 2.5rem;
}
.ml-11 {
  margin-left: 2.75rem;
}
.ml-12 {
  margin-left: 3rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.hidden {
  display: none;
}
.size-28 {
  width: 7rem;
  height: 7rem;
}
.h-\\[46\\.48px\\] {
  height: 46.48px;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-16 {
  width: 4rem;
}
.w-72 {
  width: 18rem;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-full {
  width: 100%;
}
.flex-1 {
  flex: 1 1;
}
.flex-auto {
  flex: 1 1 auto;
}
.origin-top-right {
  transform-origin: top right;
}
.appearance-none {
  appearance: none;
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-t {
  border-top-width: 1px;
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.bg-amber-50\\/50 {
  background-color: rgb(255 251 235 / 0.5);
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-center {
  text-align: center;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-tight {
  line-height: 1.25;
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-gray-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity));
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.scrollbar::-webkit-scrollbar-track {
  background-color: var(--scrollbar-track);
  border-radius: var(--scrollbar-track-radius);
}
.scrollbar::-webkit-scrollbar-track:hover {
  background-color: var(--scrollbar-track-hover, var(--scrollbar-track));
}
.scrollbar::-webkit-scrollbar-track:active {
  background-color: var(--scrollbar-track-active, var(--scrollbar-track-hover, var(--scrollbar-track)));
}
.scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb);
  border-radius: var(--scrollbar-thumb-radius);
}
.scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover, var(--scrollbar-thumb));
}
.scrollbar::-webkit-scrollbar-thumb:active {
  background-color: var(--scrollbar-thumb-active, var(--scrollbar-thumb-hover, var(--scrollbar-thumb)));
}
.scrollbar::-webkit-scrollbar-corner {
  background-color: var(--scrollbar-corner);
  border-radius: var(--scrollbar-corner-radius);
}
.scrollbar::-webkit-scrollbar-corner:hover {
  background-color: var(--scrollbar-corner-hover, var(--scrollbar-corner));
}
.scrollbar::-webkit-scrollbar-corner:active {
  background-color: var(--scrollbar-corner-active, var(--scrollbar-corner-hover, var(--scrollbar-corner)));
}
.scrollbar {
  scrollbar-width: auto;
  scrollbar-color: var(--scrollbar-thumb, initial) var(--scrollbar-track, initial);
}
.scrollbar::-webkit-scrollbar {
  display: block;
  width: var(--scrollbar-width, 16px);
  height: var(--scrollbar-height, 16px);
}
.scrollbar-thumb-neutral-200 {
  --scrollbar-thumb: #e5e5e5 !important;
}
.scrollbar-track-rounded-full {
  --scrollbar-track-radius: 9999px;
}
.scrollbar-thumb-rounded-full {
  --scrollbar-thumb-radius: 9999px;
}
/* @import "tailwindcss";



@theme {

  --color-inputbg: #3ab7bf;

} */


html {
  height: 100%;
  margin: 0;
}


body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: repeat-y;
  height: 100%;
  margin: 0;
  position: relative;
}

html,body {
  overflow-x: hidden ;
}

.caspage {
  height: 600px;
}

.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

}
.row {

  display: flex;
  flex-direction: row;
  margin: auto;
}

.maincontainer{
  margin:50px;
}
.brand {
    width:141px;
    height: 141px;
    margin-left: 20px;
    margin-top: 15px;
  }

  .Aglogo {
    width:14%;
    /* height: 35%; */
    display: flex;
    margin-left: 40px;
    margin-top: 20px;
  }


  .ndaes {
    max-width: 600px;
    max-height: 400px;
    margin-left: 30px;



  }
  .divider {
    width:610px;
    content: "";
    height: 20px;
    margin-left: 36px;
    background-color:#FFC72A;
    background-repeat:repeat-y;
   
  }
  .intro {
    color:white;
    text-align: left;
    margin-left: 40px;
    margin-top: 10px;
    font-size: small;
    width: 83%;
  }

.ant-select-selector

 {
    
    background-color: #F9FAFB !important;
 }


.Mid { 
  display: flex;
  min-height: 58vh;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 100px;
  

  width:100%;

  
} 

.Midder{
  display: flex;
  flex-direction: column;

}
/* General styling for the slider container */
#slider {
  /* overflow-x: scroll;
  margin-bottom: 100px; */
  display: flex;
  height: 100%;
  margin-bottom: 120px;
}




.blankbox{ 
  width: 100%;
  height:400px;
  display: flex;
  position: relative;
  margin-left: 10px;
  
  
  
  
}

.arrowIcon{
  cursor:pointer;
  width:92px;
  height: 212px;
  margin-top: 100px;

}
.yellowbox{

  background-color: #FFC72A;
  width:200px;
  height: 200px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0;
  padding-right: 0;
  margin-top: 100px;
  position: relative;

 
  }

  .newYellow{
    
  background-color: green;
  width:200px;
  height: 200px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 0;
  padding-right: 0;
 
  margin-top: 100px;
  position: relative;

  }
  svg{
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align:top;
  }
.Cardbox{
  display: flex;
  position: relative;
  
  
}

.applogobord{
  /* width: 120px;
  height: 120px;
  position: absolute;

  opacity: 0; */


  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none; /* Prevents hover events on the border itself */




}
.applogobord:hover{
  opacity: 1;
  width: 200px;
  height: 129px;

}


.applogo{

 
  
  /* width: 150px; */
  height: 150px;
  position: relative;


  


  

  
  
  }

/* .applogo:hover{
  filter: brightness(1.25);

} */

.tile {

  padding: 0px;
  width: -moz-fit-content;
  width: fit-content;
}

.container:hover{
  filter: brightness(1.10);
  transition: 0.4s ease;

}

.container{
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  /* display:inline-block; */

}
  .connectorcss{
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align:top;
    margin-top:130px;
    
    /* Box connectors */

position: relative;





  }

  .greenconnector{
  
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align:top;
    margin-top:225px;
    fill:green;
    position: relative;

  }



.visibnone{
  visibility: hidden;
}
.whitebox{
    background-color: white;
    width: 180px;
    height: 180px;
    border-radius: 25px;
    display: flex;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    justify-content: center;
    align-items: center;
}

.motherfooter{
  display:flex;
  margin: 0;
  width: 100%;
  overflow: hidden;
}
.motherfooter2{
  display:flex;
  flex-direction: column;
  position: relative;

  background-color: #063222;
  width: 100%;
  border-top-right-radius: 20px;
  height:auto;
  color:#388267;

  margin:0;
  top:2px;
  right: 2px;
  z-index: 5;
}

.footertext{
  color:white;
  font-family: 'Merriweather','Courier New', Courier, monospace;
  margin-top: 60px;
  font-size:x-large;
  display: flex;
  justify-content: center;

}

.imgsize{

  width: 700px;
 
}


.socials{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width:72%;
  margin-top: 50px;
/* 
height: 43px;

right: 48.83px;
top: 1147px; */
position: relative;
margin-left: 13%;

}
.socialbutton{
  fill:"#FFC72A";
  display:flex;
}
.socialbutton:hover{
  fill: white;
  transition: 250ms;




}

.footerbox{
  display: flex;
  flex-direction: column;
  
  
  position: relative;
  /* width:100%; */
  height:400px;
 

  background-color: #063222; 
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  
}

.curvedbox{
  position: relative;
  width: 101%;
  height: 150px;
  background-color: rgb(255, 255, 255);
  /* border: 1px solid white; */
  
  /* mask: radial-gradient(20px at calc(100% - 40px) 40px, transparent 98%, black) 40px -40px; */
  
  
  /* border-radius: 50%; */
  border-bottom-left-radius: 25px;
  top: -1px;
  right:1px;

  


}


.roundedcorner{
  position: relative;
  background-color: #063222;
  width:100px;
  height:200px;
  border-top-right-radius: 25px;
}


.roundedcorner2{

  display: block;
  background-color: white;
  

}

.curvedbox2{
  position: relative;
  width: 14px;
  height: 150px;
  background-color: white;
  border-top-right-radius: 50px;
  /* border: 1px solid white; */
  
  /* mask: radial-gradient(20px at calc(100% - 40px) 40px, transparent 98%, black) 40px -40px; */
  
  
  /* border-radius: 50%; */


  


}
.curvedbox3{
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #063222;
  border-top-right-radius: 25px;
  /* border: 1px solid white; */
  
  /* mask: radial-gradient(20px at calc(100% - 40px) 40px, transparent 98%, black) 40px -40px; */
  
  
  /* border-radius: 50%; */
  right:4px;
  top:1px;


  


}

/* .buttonstyle {
background-image: linear-gradient(144deg,#AF40FF, #5B42F3 50%,#00DDEB);
  border: 0;
  border-radius: 8px;
  background-color: #063222;
  border-style: none;
  color: #FFFFFF;
  font-family: "Merriweather","Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 10px;
  font-weight: 2;
  height: 40px;
  line-height: 20px;
  list-style: none;
  margin: 5px;
  padding: 10px 16px;
  position: relative;
  text-align: center;
  transition: 300ms;
  vertical-align: baseline;
  user-select: none;
  touch-action: manipulation;
}

.buttonstyle:hover {
border: 1px solid;
border-color: linear-gradient(to right, #f06, #4a90e2) 1;

  background-color: #0F5A3F;
  
  
} */

.buttondiv {
    margin-right: 20px;
}

.heading {
    color: #388267;
    font-size: 32px;
    font-family: 'Merriweather','Courier New', Courier, monospace;
}




/* CSS */
.buttonstyle {
    align-items: center;
    background-image: linear-gradient(90deg, rgba(255,199,42,1) 7%, rgba(229,201,59,1) 28%, rgba(214,202,69,1) 46%, rgba(177,205,93,1) 69%, rgba(143,208,116,1) 77%, rgba(128,209,126,1) 100%);
    border: 0;
    border-radius: 8px;
    box-sizing: border-box;
    color: #FFFFFF;
    display: inline-flex;
    font-family: sans-serif;
    font-size: 15px;
    justify-content: center;
    margin: 5px;
    padding:0px;
    width: auto;
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    white-space: nowrap;
    cursor: pointer;
}

.btnprofile {
   
    width:auto;
    
    

}
.buttonstyle:hover {
  outline:0;
  padding: 2px;
  transition: 200ms;
  
}
.buttonstyle:active {
    outline:0;
    padding: 2px;
    
  }

.buttonstyle span {
  background-color: #063222;
  padding: 14px 22px;
  border-radius: 8px;

}

.buttonstyle:hover span {
    background-color: #0F5A3F;
    padding: 12px 20px;
    border-radius: 8px;
    transition: 200ms;
    
}

.centerize {

  display: flex;
  justify-content: center;



}


.buttonforlogin {
  align-items: center;
  background-image: linear-gradient(90deg, rgba(255,199,42,1) 7%, rgba(229,201,59,1) 28%, rgba(214,202,69,1) 46%, rgba(177,205,93,1) 69%, rgba(143,208,116,1) 77%, rgba(128,209,126,1) 100%);
  border: 0;
  border-radius: 8px;
  box-sizing: border-box;
  color: #FFFFFF;
  display: inline-flex;
  font-family: sans-serif;
  /* font-size: 15px; */
  justify-content: center;
  margin: 5px;
  padding:0px;
  width: auto;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  cursor: pointer;
}


.buttonforlogin span{
  display: flex;
  justify-content: center;
  background-color: #eeeeee;
  padding: 12px 150px;
  border-radius: 8px;
  width:15px;
  cursor: pointer;
  color:rgb(58, 61, 61);
  /* font-weight: bold; */
}

.buttonforlogin:hover span {
  display: flex;
  justify-content: center;
  background-color: #fdfdfd;
  padding: 10px 148px;
  border-radius: 8px;
  transition: 200ms;
  width:14px;
  
}


.buttonforreg {
  align-items: center;
  background-image: linear-gradient(90deg, rgba(255,199,42,1) 7%, rgba(229,201,59,1) 28%, rgba(214,202,69,1) 46%, rgba(177,205,93,1) 69%, rgba(143,208,116,1) 77%, rgba(128,209,126,1) 100%);
  border: 0;
  border-radius: 8px;
  box-sizing: border-box;
  color: #FFFFFF;
  display: inline-flex;
  font-family: sans-serif;
  /* font-size: 15px; */
  justify-content: center;
  margin: 5px;
  padding:0px;
  width: auto;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  cursor: pointer;
}


.buttonforreg span{
  display: flex;
  justify-content: center;
  background-color: #01916d ;
  padding: 12px 150px;
  border-radius: 8px;
  width:15px;
  cursor: pointer;
}

.buttonforreg:hover span {
  display: flex;
  justify-content: center;
  background-color: #028365 ;
  padding: 10px 148px;
  border-radius: 8px;
  transition: 200ms;
  width:14px;
  
}


.profileback{
  display: flex;
  /* background-color: aliceblue; */
 
  width: 100%;
}



.background {

  
  margin-top: 200px;



}
.deptset{
  display: flex;
}
.profileform {
  /* background-color: bisque ; */
  width:80%;
  margin-left: 20px;
  margin-bottom: 60px;


}

.headbox {
  background-color: #063222;
  color:white;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 72px;
  border-radius: 5px;
  margin-left: 40px;
  margin-top: 40px;
}


.centerizeboxes{


  display: flex;
  justify-content: center;

}

.brand:hover{
  filter: brightness(1.50);
  transition: 0.4s ease;
  cursor: pointer;

}


@media (max-width: 768px) {
    .heading {
        font-size: 20px;
    }
    .footertext {
      font-size: medium;
    }

    .socialbutton {
      width:25px;
      height: 25px;
    }

    .brand {
      width:100px;
      height:100px;
    }

    

    .buttonstyle span {
      
      padding: 6px 16px;
    
 
    }
    
    .buttonstyle:hover span {
        padding: 4px 14px;
  

        
    }
    .buttonforreg span{
      padding:8px 80px;
    }
    .buttonforreg span:hover{
      padding:6px 80px;
    }
    .buttonforlogin span{
      padding:8px 80px;
    }
    .buttonforlogin span:hover{
      padding:6px 80px;
    }
    

    


    .background{
      display: none;
    }

    .intro {
    color:white;
    text-align: left;
    margin-left: 40px;
    margin-top: 10px;
    font-size: small;
    
    padding: 10px;
    
  }

@media (max-width: 460px) {





  .Aglogo{
    width: 50%;
  }

  .footertext{
    margin-left: 15px;
  }

  .curvedbox3{
    width:138%;
  }
}


    








}


.placeholder\\:text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}


.data-\\[closed\\]\\:scale-95[data-closed] {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.data-\\[closed\\]\\:transform[data-closed] {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.data-\\[closed\\]\\:opacity-0[data-closed] {
  opacity: 0;
}


.data-\\[enter\\]\\:duration-100[data-enter] {
  transition-duration: 100ms;
}


.data-\\[leave\\]\\:duration-75[data-leave] {
  transition-duration: 75ms;
}


.data-\\[enter\\]\\:ease-out[data-enter] {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}


.data-\\[leave\\]\\:ease-in[data-leave] {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}


.hover\\:scrollbar-thumb-neutral-300 {
  --scrollbar-thumb-hover: #d4d4d4 !important;
}


.focus\\:border-lime-950:focus {
  --tw-border-opacity: 1;
  border-color: rgb(26 46 5 / var(--tw-border-opacity));
}


.focus\\:border-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity));
}


.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}


.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}


.focus\\:ring-inset:focus {
  --tw-ring-inset: inset;
}


.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}


.focus\\:ring-indigo-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity));
}


.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity));
}


@media (min-width: 640px) {

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:leading-6 {
    line-height: 1.5rem;
  }
}


@media (min-width: 1024px) {

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AACnB;;;;;;;;GAQG;;;AAGH;EACE,YAAY;EACZ,SAAS;AACX;;;AAGA;EACE,yDAAwE;EACxE,2BAA2B;EAC3B,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;;AAEnB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;AACA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;;EAGA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;;;;EAInB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;IACxB,0BAA0B;;EAE5B;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;EACZ;;AAEF;;;;IAII,oCAAoC;CACvC;;;AAGD;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;;;EAGpB,UAAU;;;AAGZ;;AAEA;EACE,aAAa;EACb,sBAAsB;;AAExB;AACA,6CAA6C;AAC7C;EACE;yBACuB;EACvB,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;;;;AAKA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;;;;;AAKnB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,iBAAiB;;AAEnB;AACA;;EAEE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;;;EAGlB;;EAEA;;EAEA,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;;EAEhB,iBAAiB;EACjB,kBAAkB;;EAElB;EACA;IACE,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;EACpB;AACF;EACE,aAAa;EACb,kBAAkB;;;AAGpB;;AAEA;EACE;;;;eAIa;;;EAGb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,oBAAoB,EAAE,+CAA+C;;;;;AAKvE;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;;AAEf;;;AAGA;;;;EAIE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;;;;;;;;;;EAUlB;;AAEF;;;GAGG;;AAEH;;EAEE,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;;AAEvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;;AAE5B;EACE;IACE,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,gBAAgB;;IAEhB,mBAAmB;;AAEvB,kBAAkB;;;;;;EAMhB;;EAEA;;IAEE,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;;EAEpB;;;;AAIF;EACE,kBAAkB;AACpB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,2CAA2C;IAC3C,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;;EAElB,yBAAyB;EACzB,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,aAAa;;EAEb,QAAQ;EACR,OAAO;EACP,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;;AAEzB;;AAEA;;EAEE,YAAY;;AAEd;;;AAGA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;;;cAIc;AACd,kBAAkB;AAClB,gBAAgB;;AAEhB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;;;;;AAKnB;;AAEA;EACE,aAAa;EACb,sBAAsB;;;EAGtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;;;EAGZ,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,6BAA6B;;EAE7B,8FAA8F;;;EAG9F,wBAAwB;EACxB,+BAA+B;EAC/B,SAAS;EACT,SAAS;;;;;AAKX;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;;AAGA;;EAEE,cAAc;EACd,uBAAuB;;;AAGzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;;EAE7B,8FAA8F;;;EAG9F,wBAAwB;;;;;;AAM1B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;;EAE7B,8FAA8F;;;EAG9F,wBAAwB;EACxB,SAAS;EACT,OAAO;;;;;;AAMT;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8BG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,6DAA6D;AACjE;;;;;AAKA,QAAQ;AACR;IACI,mBAAmB;IACnB,0LAA0L;IAC1L,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,UAAU;;;;AAId;AACA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;;AAEnB;AACA;IACI,SAAS;IACT,YAAY;;EAEd;;AAEF;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;;;;AAIzB;;;AAGA;EACE,mBAAmB;EACnB,0LAA0L;EAC1L,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;;AAEZ;;;AAGA;EACE,mBAAmB;EACnB,0LAA0L;EAC1L,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;;AAEZ;;;AAGA;EACE,aAAa;EACb,iCAAiC;;EAEjC,WAAW;AACb;;;;AAIA;;;EAGE,iBAAiB;;;;AAInB;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;;;AAGrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;;;EAGE,aAAa;EACb,uBAAuB;;AAEzB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;;AAEjB;;;AAGA;IACI;QACI,eAAe;IACnB;IACA;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;MACV,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;;;IAIA;;MAEE,iBAAiB;;;IAGnB;;IAEA;QACI,iBAAiB;;;;IAIrB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;;;;;;IAMA;MACE,aAAa;IACf;;IAEA;IACA,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;;IAEhB,aAAa;;EAEf;;AAEF;;;;;;EAME;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;AACF;;;;;;;;;;;;AAYA;;;AAn0BA;EAAA,oBAm0BC;EAn0BD;AAm0BC;;;AAn0BD;EAAA,iBAm0BC;EAn0BD,iBAm0BC;EAn0BD;AAm0BC;;;AAn0BD;EAAA;AAm0BC;;;AAn0BD;EAAA;AAm0BC;;;AAn0BD;EAAA;AAm0BC;;;AAn0BD;EAAA;AAm0BC;;;AAn0BD;EAAA;AAm0BC;;;AAn0BD;EAAA;AAm0BC;;;AAn0BD;EAAA;AAm0BC;;;AAn0BD;EAAA,sBAm0BC;EAn0BD;AAm0BC;;;AAn0BD;EAAA,sBAm0BC;EAn0BD;AAm0BC;;;AAn0BD;EAAA,8BAm0BC;EAn0BD;AAm0BC;;;AAn0BD;EAAA,2GAm0BC;EAn0BD,yGAm0BC;EAn0BD;AAm0BC;;;AAn0BD;EAAA;AAm0BC;;;AAn0BD;EAAA,oBAm0BC;EAn0BD;AAm0BC;;;AAn0BD;EAAA,oBAm0BC;EAn0BD;AAm0BC;;;AAn0BD;EAAA,oBAm0BC;EAn0BD;AAm0BC;;;AAn0BD;;EAAA;IAAA,iBAm0BC;IAn0BD;EAm0BC;;EAn0BD;IAAA;EAm0BC;;EAn0BD;IAAA;EAm0BC;;EAn0BD;IAAA,mBAm0BC;IAn0BD;EAm0BC;;EAn0BD;IAAA;EAm0BC;AAAA;;;AAn0BD;;EAAA;IAAA,oBAm0BC;IAn0BD;EAm0BC;;EAn0BD;IAAA,kBAm0BC;IAn0BD;EAm0BC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n/* @import \"tailwindcss\";\n\n\n\n@theme {\n\n  --color-inputbg: #3ab7bf;\n\n} */\n\n\nhtml {\n  height: 100%;\n  margin: 0;\n}\n\n\nbody {\n  background-image: url(\"./components/utilities/assets/backgroundimg.png\");\n  background-repeat: repeat-y;\n  height: 100%;\n  margin: 0;\n  position: relative;\n}\n\nhtml,body {\n  overflow-x: hidden ;\n}\n\n.caspage {\n  height: 600px;\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n\n}\n.row {\n\n  display: flex;\n  flex-direction: row;\n  margin: auto;\n}\n\n.maincontainer{\n  margin:50px;\n}\n.brand {\n    width:141px;\n    height: 141px;\n    margin-left: 20px;\n    margin-top: 15px;\n  }\n\n  .Aglogo {\n    width:14%;\n    /* height: 35%; */\n    display: flex;\n    margin-left: 40px;\n    margin-top: 20px;\n  }\n\n\n  .ndaes {\n    max-width: 600px;\n    max-height: 400px;\n    margin-left: 30px;\n\n\n\n  }\n  .divider {\n    width:610px;\n    content: \"\";\n    height: 20px;\n    margin-left: 36px;\n    background-color:#FFC72A;\n    background-repeat:repeat-y;\n   \n  }\n  .intro {\n    color:white;\n    text-align: left;\n    margin-left: 40px;\n    margin-top: 10px;\n    font-size: small;\n    width: 83%;\n  }\n\n.ant-select-selector\n\n {\n    \n    background-color: #F9FAFB !important;\n }\n\n\n.Mid { \n  display: flex;\n  min-height: 58vh;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 100px;\n  \n\n  width:100%;\n\n  \n} \n\n.Midder{\n  display: flex;\n  flex-direction: column;\n\n}\n/* General styling for the slider container */\n#slider {\n  /* overflow-x: scroll;\n  margin-bottom: 100px; */\n  display: flex;\n  height: 100%;\n  margin-bottom: 120px;\n}\n\n\n\n\n.blankbox{ \n  width: 100%;\n  height:400px;\n  display: flex;\n  position: relative;\n  margin-left: 10px;\n  \n  \n  \n  \n}\n\n.arrowIcon{\n  cursor:pointer;\n  width:92px;\n  height: 212px;\n  margin-top: 100px;\n\n}\n.yellowbox{\n\n  background-color: #FFC72A;\n  width:200px;\n  height: 200px;\n  border-radius: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 0;\n  padding-right: 0;\n  margin-top: 100px;\n  position: relative;\n\n \n  }\n\n  .newYellow{\n    \n  background-color: green;\n  width:200px;\n  height: 200px;\n  border-radius: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin-right: 0;\n  padding-right: 0;\n \n  margin-top: 100px;\n  position: relative;\n\n  }\n  svg{\n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align:top;\n  }\n.Cardbox{\n  display: flex;\n  position: relative;\n  \n  \n}\n\n.applogobord{\n  /* width: 120px;\n  height: 120px;\n  position: absolute;\n\n  opacity: 0; */\n\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none; /* Prevents hover events on the border itself */\n\n\n\n\n}\n.applogobord:hover{\n  opacity: 1;\n  width: 200px;\n  height: 129px;\n\n}\n\n\n.applogo{\n\n \n  \n  /* width: 150px; */\n  height: 150px;\n  position: relative;\n\n\n  \n\n\n  \n\n  \n  \n  }\n\n/* .applogo:hover{\n  filter: brightness(1.25);\n\n} */\n\n.tile {\n\n  padding: 0px;\n  width: fit-content;\n}\n\n.container:hover{\n  filter: brightness(1.10);\n  transition: 0.4s ease;\n\n}\n\n.container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  /* display:inline-block; */\n\n}\n  .connectorcss{\n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align:top;\n    margin-top:130px;\n    \n    /* Box connectors */\n\nposition: relative;\n\n\n\n\n\n  }\n\n  .greenconnector{\n  \n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align:top;\n    margin-top:225px;\n    fill:green;\n    position: relative;\n\n  }\n\n\n\n.visibnone{\n  visibility: hidden;\n}\n.whitebox{\n    background-color: white;\n    width: 180px;\n    height: 180px;\n    border-radius: 25px;\n    display: flex;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    justify-content: center;\n    align-items: center;\n}\n\n.motherfooter{\n  display:flex;\n  margin: 0;\n  width: 100%;\n  overflow: hidden;\n}\n.motherfooter2{\n  display:flex;\n  flex-direction: column;\n  position: relative;\n\n  background-color: #063222;\n  width: 100%;\n  border-top-right-radius: 20px;\n  height:auto;\n  color:#388267;\n\n  margin:0;\n  top:2px;\n  right: 2px;\n  z-index: 5;\n}\n\n.footertext{\n  color:white;\n  font-family: 'Merriweather','Courier New', Courier, monospace;\n  margin-top: 60px;\n  font-size:x-large;\n  display: flex;\n  justify-content: center;\n\n}\n\n.imgsize{\n\n  width: 700px;\n \n}\n\n\n.socials{\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width:72%;\n  margin-top: 50px;\n/* \nheight: 43px;\n\nright: 48.83px;\ntop: 1147px; */\nposition: relative;\nmargin-left: 13%;\n\n}\n.socialbutton{\n  fill:\"#FFC72A\";\n  display:flex;\n}\n.socialbutton:hover{\n  fill: white;\n  transition: 250ms;\n\n\n\n\n}\n\n.footerbox{\n  display: flex;\n  flex-direction: column;\n  \n  \n  position: relative;\n  /* width:100%; */\n  height:400px;\n \n\n  background-color: #063222; \n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  overflow: hidden;\n  \n}\n\n.curvedbox{\n  position: relative;\n  width: 101%;\n  height: 150px;\n  background-color: rgb(255, 255, 255);\n  /* border: 1px solid white; */\n  \n  /* mask: radial-gradient(20px at calc(100% - 40px) 40px, transparent 98%, black) 40px -40px; */\n  \n  \n  /* border-radius: 50%; */\n  border-bottom-left-radius: 25px;\n  top: -1px;\n  right:1px;\n\n  \n\n\n}\n\n\n.roundedcorner{\n  position: relative;\n  background-color: #063222;\n  width:100px;\n  height:200px;\n  border-top-right-radius: 25px;\n}\n\n\n.roundedcorner2{\n\n  display: block;\n  background-color: white;\n  \n\n}\n\n.curvedbox2{\n  position: relative;\n  width: 14px;\n  height: 150px;\n  background-color: white;\n  border-top-right-radius: 50px;\n  /* border: 1px solid white; */\n  \n  /* mask: radial-gradient(20px at calc(100% - 40px) 40px, transparent 98%, black) 40px -40px; */\n  \n  \n  /* border-radius: 50%; */\n\n\n  \n\n\n}\n.curvedbox3{\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: #063222;\n  border-top-right-radius: 25px;\n  /* border: 1px solid white; */\n  \n  /* mask: radial-gradient(20px at calc(100% - 40px) 40px, transparent 98%, black) 40px -40px; */\n  \n  \n  /* border-radius: 50%; */\n  right:4px;\n  top:1px;\n\n\n  \n\n\n}\n\n/* .buttonstyle {\nbackground-image: linear-gradient(144deg,#AF40FF, #5B42F3 50%,#00DDEB);\n  border: 0;\n  border-radius: 8px;\n  background-color: #063222;\n  border-style: none;\n  color: #FFFFFF;\n  font-family: \"Merriweather\",\"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 10px;\n  font-weight: 2;\n  height: 40px;\n  line-height: 20px;\n  list-style: none;\n  margin: 5px;\n  padding: 10px 16px;\n  position: relative;\n  text-align: center;\n  transition: 300ms;\n  vertical-align: baseline;\n  user-select: none;\n  touch-action: manipulation;\n}\n\n.buttonstyle:hover {\nborder: 1px solid;\nborder-color: linear-gradient(to right, #f06, #4a90e2) 1;\n\n  background-color: #0F5A3F;\n  \n  \n} */\n\n.buttondiv {\n    margin-right: 20px;\n}\n\n.heading {\n    color: #388267;\n    font-size: 32px;\n    font-family: 'Merriweather','Courier New', Courier, monospace;\n}\n\n\n\n\n/* CSS */\n.buttonstyle {\n    align-items: center;\n    background-image: linear-gradient(90deg, rgba(255,199,42,1) 7%, rgba(229,201,59,1) 28%, rgba(214,202,69,1) 46%, rgba(177,205,93,1) 69%, rgba(143,208,116,1) 77%, rgba(128,209,126,1) 100%);\n    border: 0;\n    border-radius: 8px;\n    box-sizing: border-box;\n    color: #FFFFFF;\n    display: inline-flex;\n    font-family: sans-serif;\n    font-size: 15px;\n    justify-content: center;\n    margin: 5px;\n    padding:0px;\n    width: auto;\n    text-decoration: none;\n    user-select: none;\n    -webkit-user-select: none;\n    touch-action: manipulation;\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.btnprofile {\n   \n    width:auto;\n    \n    \n\n}\n.buttonstyle:hover {\n  outline:0;\n  padding: 2px;\n  transition: 200ms;\n  \n}\n.buttonstyle:active {\n    outline:0;\n    padding: 2px;\n    \n  }\n\n.buttonstyle span {\n  background-color: #063222;\n  padding: 14px 22px;\n  border-radius: 8px;\n\n}\n\n.buttonstyle:hover span {\n    background-color: #0F5A3F;\n    padding: 12px 20px;\n    border-radius: 8px;\n    transition: 200ms;\n    \n}\n\n.centerize {\n\n  display: flex;\n  justify-content: center;\n\n\n\n}\n\n\n.buttonforlogin {\n  align-items: center;\n  background-image: linear-gradient(90deg, rgba(255,199,42,1) 7%, rgba(229,201,59,1) 28%, rgba(214,202,69,1) 46%, rgba(177,205,93,1) 69%, rgba(143,208,116,1) 77%, rgba(128,209,126,1) 100%);\n  border: 0;\n  border-radius: 8px;\n  box-sizing: border-box;\n  color: #FFFFFF;\n  display: inline-flex;\n  font-family: sans-serif;\n  /* font-size: 15px; */\n  justify-content: center;\n  margin: 5px;\n  padding:0px;\n  width: auto;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n\n.buttonforlogin span{\n  display: flex;\n  justify-content: center;\n  background-color: #eeeeee;\n  padding: 12px 150px;\n  border-radius: 8px;\n  width:15px;\n  cursor: pointer;\n  color:rgb(58, 61, 61);\n  /* font-weight: bold; */\n}\n\n.buttonforlogin:hover span {\n  display: flex;\n  justify-content: center;\n  background-color: #fdfdfd;\n  padding: 10px 148px;\n  border-radius: 8px;\n  transition: 200ms;\n  width:14px;\n  \n}\n\n\n.buttonforreg {\n  align-items: center;\n  background-image: linear-gradient(90deg, rgba(255,199,42,1) 7%, rgba(229,201,59,1) 28%, rgba(214,202,69,1) 46%, rgba(177,205,93,1) 69%, rgba(143,208,116,1) 77%, rgba(128,209,126,1) 100%);\n  border: 0;\n  border-radius: 8px;\n  box-sizing: border-box;\n  color: #FFFFFF;\n  display: inline-flex;\n  font-family: sans-serif;\n  /* font-size: 15px; */\n  justify-content: center;\n  margin: 5px;\n  padding:0px;\n  width: auto;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n\n.buttonforreg span{\n  display: flex;\n  justify-content: center;\n  background-color: #01916d ;\n  padding: 12px 150px;\n  border-radius: 8px;\n  width:15px;\n  cursor: pointer;\n}\n\n.buttonforreg:hover span {\n  display: flex;\n  justify-content: center;\n  background-color: #028365 ;\n  padding: 10px 148px;\n  border-radius: 8px;\n  transition: 200ms;\n  width:14px;\n  \n}\n\n\n.profileback{\n  display: flex;\n  /* background-color: aliceblue; */\n \n  width: 100%;\n}\n\n\n\n.background {\n\n  \n  margin-top: 200px;\n\n\n\n}\n.deptset{\n  display: flex;\n}\n.profileform {\n  /* background-color: bisque ; */\n  width:80%;\n  margin-left: 20px;\n  margin-bottom: 60px;\n\n\n}\n\n.headbox {\n  background-color: #063222;\n  color:white;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  padding-left: 72px;\n  border-radius: 5px;\n  margin-left: 40px;\n  margin-top: 40px;\n}\n\n\n.centerizeboxes{\n\n\n  display: flex;\n  justify-content: center;\n\n}\n\n.brand:hover{\n  filter: brightness(1.50);\n  transition: 0.4s ease;\n  cursor: pointer;\n\n}\n\n\n@media (max-width: 768px) {\n    .heading {\n        font-size: 20px;\n    }\n    .footertext {\n      font-size: medium;\n    }\n\n    .socialbutton {\n      width:25px;\n      height: 25px;\n    }\n\n    .brand {\n      width:100px;\n      height:100px;\n    }\n\n    \n\n    .buttonstyle span {\n      \n      padding: 6px 16px;\n    \n \n    }\n    \n    .buttonstyle:hover span {\n        padding: 4px 14px;\n  \n\n        \n    }\n    .buttonforreg span{\n      padding:8px 80px;\n    }\n    .buttonforreg span:hover{\n      padding:6px 80px;\n    }\n    .buttonforlogin span{\n      padding:8px 80px;\n    }\n    .buttonforlogin span:hover{\n      padding:6px 80px;\n    }\n    \n\n    \n\n\n    .background{\n      display: none;\n    }\n\n    .intro {\n    color:white;\n    text-align: left;\n    margin-left: 40px;\n    margin-top: 10px;\n    font-size: small;\n    \n    padding: 10px;\n    \n  }\n\n@media (max-width: 460px) {\n\n\n\n\n\n  .Aglogo{\n    width: 50%;\n  }\n\n  .footertext{\n    margin-left: 15px;\n  }\n\n  .curvedbox3{\n    width:138%;\n  }\n}\n\n\n    \n\n\n\n\n\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
